// Phone helpers for the public school profile.

/** Strip everything a `tel:` link cannot use. Returns null when unusable. */
export const toTelHref = (rawPhone) => {
  if (typeof rawPhone !== 'string') return null;

  const trimmed = rawPhone.trim();
  if (!trimmed) return null;

  const hasLeadingPlus = trimmed.startsWith('+');
  const digits = trimmed.replace(/\D/g, '');

  // Too short to be a real number.
  if (digits.length < 6) return null;

  return `tel:${hasLeadingPlus ? '+' : ''}${digits}`;
};

/** Display form of a phone number: collapse odd spacing, keep the school's format. */
export const formatPhoneNumber = (rawPhone) => {
  if (typeof rawPhone !== 'string') return null;

  const cleaned = rawPhone.trim().replace(/\s+/g, ' ');
  if (!cleaned) return null;
  if (!toTelHref(cleaned)) return null;

  // Group a bare international number for readability: +233 31 423 2321
  if (/^\+\d{8,15}$/.test(cleaned)) {
    const digits = cleaned.slice(1);
    const country = digits.slice(0, 3);
    const rest = digits.slice(3);
    const groups = rest.match(/.{1,3}/g) || [];
    return `+${country} ${groups.join(' ')}`.trim();
  }

  return cleaned;
};
